import type { AgentApiJobSourcesItem } from '@/types/serializers';

type Props = {
  lists: AgentApiJobSourcesItem[];
  onSelectJobSource: (id: number, name: string) => void;
};

export default function JobSourceList({ lists, onSelectJobSource }: Props) {
  return (
    <div className="max-h-[480px] w-[350px] animate-in overflow-hidden overflow-y-auto rounded bg-white shadow-[0px_0px_12px_0px_#00000033] duration-200 fade-in-0 slide-in-from-top-2">
      {lists.map((l) => {
        return (
          <div
            key={l.id}
            className="flex h-xxl cursor-pointer items-center justify-between px-2 text-sm hover:bg-gray"
            onClick={() => onSelectJobSource(l.id, l.title)}
          >
            <span className="truncate">{l.title}</span>
            <span className="ml-2 shrink-0 text-xs text-sub">{l.source_display_type}</span>
          </div>
        );
      })}
    </div>
  );
}
